var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import EmberDataBaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import allowDeprecatedOverrides from '@square/dashboard-utilities/utils/compat/allow-deprecated-overrides';
import { dependentKeyCompat } from '@ember/object/compat';
import { ModifierToggleOverrideType } from '@square/dashboard-items-data/utils/modifier-constants';
let ItemModifierOptionOverride = (_dec = attr('boolean'), _dec2 = attr('enum', {
  enumClass: ModifierToggleOverrideType,
  defaultValue: ModifierToggleOverrideType.NOT_SET
}), _dec3 = attr('boolean'), _dec4 = attr('enum', {
  enumClass: ModifierToggleOverrideType,
  defaultValue: ModifierToggleOverrideType.NOT_SET
}), _dec5 = attr('string'), _dec6 = computed('isNew', 'onByDefault', {
  get() {
    const hasDirtyAttributes = Object.keys(this.changedAttributes()).length > 0;
    return hasDirtyAttributes && !this.isNew;
  }
}), _class = class ItemModifierOptionOverride extends EmberDataBaseFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "onByDefault", _descriptor, this);
    // being deprecated
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - TS doesn't like the enumClass type
    _initializerDefineProperty(this, "onByDefaultOverride", _descriptor2, this);
    _initializerDefineProperty(this, "hiddenOnline", _descriptor3, this);
    // being deprecated
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - TS doesn't like the enumClass type
    _initializerDefineProperty(this, "hiddenOnlineOverride", _descriptor4, this);
    _initializerDefineProperty(this, "itemModifierOptionId", _descriptor5, this);
    _initializerDefineProperty(this, "store", _descriptor6, this);
    _initializerDefineProperty(this, "isDirty", _descriptor7, this);
  }
  // this can be converted to a getter, will require updating the item duplication test
  get itemModifierOption() {
    return this.itemModifierOptionId ? this.store.peekRecord('item-modifier-option', this.itemModifierOptionId) : null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "onByDefault", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onByDefaultOverride", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hiddenOnline", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hiddenOnlineOverride", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "itemModifierOptionId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "itemModifierOption", [dependentKeyCompat, allowDeprecatedOverrides], Object.getOwnPropertyDescriptor(_class.prototype, "itemModifierOption"), _class.prototype), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ItemModifierOptionOverride as default };
ItemModifierOptionOverride.reopenClass({
  _modelNameForMigration: 'item-modifier-option-override',
  // Return true if this option override is equivalent to not having an override
  isDefault(override) {
    return override.onByDefault === false;
  }
});